import * as React from "react";
import type { SVGProps } from "react";
const SvgImageUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 21.6 16.2 12l4.8 4.8M6 21.6h12a3.6 3.6 0 0 0 3.6-3.6v-6M6 21.6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h7.8m3 2.443L19.254 2.4m0 0L21.6 4.732M19.254 2.4v6M9.6 7.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
    />
  </svg>
);
export default SvgImageUp;
